<template>
  <div class="container">
    <img class="head" src="@/assets/kefu.png" />

    <div class="content">
      <div class="text" v-if="type === 1">
        <div v-html="content" style="text-align: justify"></div>
        <!-- //t改 -->
        <div
          v-for="(item, index) in selectarr"
          :key="index"
          @click="getquestion(item.id, item.title, item, item.dep_id)"
        >
          <p>
            {{ ++index }}. <span class="text-blue">{{ item.title }}</span>
          </p>
        </div>
        <div
          v-if="
            !selectarr.length &&
            content.search('您好，泰州公安微警务智能客服为您服务') == -1 &&
            content !=
              '您的问题我暂时回答不了，请拨打咨询电话或前往窗口咨询，回复“人工服务”获取咨询电话列表。谢谢！'
          "
          style="display: flex"
        >
          <div v-if="rgfw" style="" class="yy" @click="goyy()">我要预约</div>
          <div class="yy" @click="gojwdt()">警务地图</div>
        </div>
      </div>
      <img
        class="img"
        :src="content"
        v-else-if="type === 2"
        @click="preview(content)"
      />
    </div>
  </div>
</template>

<script>
import ImagePreview from "vant/lib/image-preview";
export default {
  name: "LeftItem",
  props: ["id", "type", "content", "selectarr"],
  data: () => {
    return {
      seleitem: "",
      rgfw: true,
    };
  },
  created() {
    // console.log(this.selectarr, "1111");
    var content = sessionStorage.getItem("content");
    if (content) {
      console.log(this.rgfw, 1);
      this.rgfw = false;
    }
    // if (this.selectarr.length) {
    //   if (this.selectarr[0].title == "人工服务") {
    //     this.rgfw = false;
    //   }
    // }
  },
  methods: {
    preview(url) {
      ImagePreview([url]);
    },
    //t改
    getquestion(id, title, item, dep_id) {
      sessionStorage.setItem("question_type", item.type);
      sessionStorage.setItem("seleitem", JSON.stringify(item));
      if (item.title == "人工服务") {
        localStorage.setItem("seleitem", JSON.stringify(item));
      }
      if (item.is_matter) {
        if (item.is_matter == 1) {
          localStorage.setItem("seleitem", JSON.stringify(item));
        }
      }
      this.$emit("problem", id, title, dep_id);
    },
    goyy() {
      this.$emit("make");
    },
    gojwdt() {
      location.href =
        "http://tzwjw.gaj.taizhou.gov.cn/newadmin/tz_app/tzwjw/#/testjwdt";
    },
  },
};
</script>

<style scoped lang="scss">
.yy {
  padding: 2px 8px;
  border: 1px solid #aeaefb;
  border-radius: 12px;
  margin-right: 10px;
  margin-top: 10px;
}
.container {
  display: flex;
  padding: 10px 15px;
  margin-right: 60px;

  .head {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #eee;
  }

  .content {
    margin-left: 10px;
    margin-top: 10px;

    .text {
      background-color: white;
      border-bottom-right-radius: 10px;
      padding: 5px 12px;
      font-size: 14px;
      color: black;
    }

    .img {
      width: 100px;
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  }
}
</style>